import MiscHeading from '@pc/components/Works/Panel/shared/Heading/MiscHeading'
import type { FeatureCategory, Feature } from '@pc/components/Works/Panel/types'
import FeatureBox from './FeatureBox'
import FeatureItem from './FeatureItem'

interface PropsType {
  featureCategories: FeatureCategory[]
  mappedFeatures: Record<string, Feature[]>
  selectedFeatureIds: string[]
  changeState: (arg: any) => void
}

const FeatureList = (props: PropsType) => {
  const { featureCategories, mappedFeatures, selectedFeatureIds, changeState } = props

  return (
    <>
      {featureCategories.map((featureCategory) => {
        const { id, attributes } = featureCategory
        return (
          <FeatureBox key={id}>
            <MiscHeading>{attributes.name}</MiscHeading>
            <FeatureItem features={mappedFeatures[id]} selectedFeatureIds={selectedFeatureIds} changeState={changeState} />
          </FeatureBox>
        )
      })}
    </>
  )
}

export default FeatureList
